import * as React from "react";
import Drawer from "@mui/material/Drawer";
import close from "../../assets/svgs/cross-icon.svg";
import { DrawerStyles } from "./DrawersStyles";
import { Box, SxProps, Theme, Typography } from "@mui/material";
import { CLOSE } from "../../constants/Constants";
import styled from "@emotion/styled";

interface ReusableDrawerProps {
  open: boolean;
  toggleDrawer: () => void;
  anchor?: "left" | "right" | "top" | "bottom";
  heading?: string;
  additionalClass?: SxProps<Theme>;
  children?: React.ReactNode;
  type?: "primary" | "secondary";
}
const StyledDrawer = styled(Drawer)<{ type: string }>(({ type }) => ({
  "& .MuiDrawer-paper": {
    borderTopLeftRadius: type === "secondary" ? "12px !important" : "0px",
    borderTopRightRadius: type === "secondary" ? "12px !important" : "0px",
  },
}));
const Drawers: React.FC<ReusableDrawerProps> = ({
  open,
  toggleDrawer,
  anchor = "right",
  heading,
  children,
  additionalClass,
  type = "primary",
}) => {
  return (
    <StyledDrawer
      id="drawer-container"
      data-test-id="test-drawer-container"
      aria-label={`${type} drawer`}
      type={type}
      anchor={anchor}
      open={open}
      onClose={toggleDrawer}
    >
      {type !== "secondary" && (
        <Box 
          id="drawer-heading-container"
          data-test-id="test-drawer-heading-container"
          aria-label="Drawer header"
          sx={DrawerStyles.headingContainer}
        >
          <Typography 
            id="drawer-heading"
            data-test-id="test-drawer-heading"
            aria-label="Drawer title"
            sx={DrawerStyles.heading}
          >
            {heading}
          </Typography>
          <Box 
            id="drawer-close-button"
            data-test-id="test-drawer-close-button"
            aria-label="Close drawer"
            sx={DrawerStyles.close}
          >
            <img 
              id="drawer-close-icon"
              data-test-id="test-drawer-close-icon"
              aria-label="Close icon"
              src={close} 
              alt={CLOSE} 
              onClick={toggleDrawer} 
            />
          </Box>
        </Box>
      )}

      <Box 
        id="drawer-content"
        data-test-id="test-drawer-content"
        aria-label="Drawer content"
        sx={Object.assign({}, DrawerStyles.children, additionalClass)}
      >
        {children}
      </Box>
    </StyledDrawer>
  );
};

export default Drawers;
